<section class="employee-list" id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang.employees}}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.EMPLOYEE_LIST">{{lang.humanResources }}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.EMPLOYEE_LIST">{{ lang.employees }}</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" class="active"><a href="#listTab" aria-controls="feedTab" role="tab"
                    data-toggle="tab">{{lang?.hired_emp}}</a></li>

                    <li role="presentation" class=""><a href="#resignTab" aria-controls="feedTab" role="tab"
                      data-toggle="tab">{{lang?.reasigned_emp}}</a></li>
                    <!-- <li role="presentation"><a href="#skills" aria-controls="skills" role="tab"


                      data-toggle="tab">Skills</a></li>
                  <li role="presentation"><a href="#skillsanalysis" aria-controls="skillsanalysis" role="tab"
                      data-toggle="tab">Skills Analysis</a></li>
                  <li role="presentation"><a href="#courseslist" aria-controls="skillsanalysis" role="tab"
                      data-toggle="tab">Courses List</a></li>

                  <li role="presentation"><a href="#searchforcourses" aria-controls="searchforcourses" role="tab"
                      data-toggle="tab">Search for Courses</a></li>


                  <li role="presentation"><a href="#coursesstatus" aria-controls="coursesstatus" role="tab"
                      data-toggle="tab">Courses Status</a></li> -->
                </ul>


                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="listTab">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">

                          <a class="plus-add" (click)="addEmployee()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

                          <a class="plus-import" data-toggle="modal" data-target="#datatableImport1" data-action="show"
                            data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>


                          <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="search"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                      

                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover" id="table1" *ngIf="records">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox" value=""><i></i>
                              </label>
                            </th>
                            <th>{{ lang.sno }}</th>
                            <th>{{ lang.name }}</th>
                            <th>{{ lang.surname }}</th>
                            <th>{{ lang.age }}</th>
                            <th>{{ lang.email }}</th>
                            <th>{{ lang.phone }}</th>
                            <th>{{ lang.task }}</th>
                            <th>{{ lang.qualifications }}</th>
                            <th>{{ lang.assumptionData }}</th>
                            <th style="display: none;">{{ lang.taxCode }}</th>
                            <th style="display: none;">{{ lang.dateofBirth }}</th>
                            <th style="display: none;">{{ lang.placeofBirth }}</th>
                            <th style="display: none;">{{ lang.address }}</th>
                            <th style="display: none;">{{ lang.titleofStudy }}</th>
                            <th style="display: none;">{{ lang.hourlyCost }}</th>
                            <!-- <th>{{ lang.status }}</th>  -->
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody dragula="records" [(dragulaModel)]="records">
                          <tr *ngFor="let record of records let i = index" id="{{record.employeeId}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td><a
                                [routerLink]="['/'+AppFrontRoutes.EMPLOYEE_VIEW+'/'+record.employeeId]">{{record.employee_name}}</a>
                            </td>
                            <td>{{record.employee_surname}}</td>
                            <td>{{record.age}}</td>
                            <td>{{record.employee_email}}</td>
                            <td>{{record.employee_phone}}</td>
                            <td>{{record.employee_task}}</td>
                            <td>{{record.employee_qualification}}</td>
                            <td>{{record.employee_assumption_date}}</td>
                            <td style="display: none;">{{record.employee_tax_code}}</td>
                            <td style="display: none;">{{record.emp_dob}}</td>
                            <td style="display: none;">{{record.employee_placeOfbirth}}</td>
                            <td style="display: none;">{{record.employee_address}}</td>
                            <td style="display: none;">{{record.employee_timeOfstudy}}</td>
                            <td style="display: none;">{{record.employee_houly_cost}}</td>
                             <!-- <td>
                              <div [innerHTML]="record.status"></div>
                            </td> -->
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="blue_action" (click)="delete(record.employeeId)"><i
                                        class="fa fa-trash"></i> {{ lang.erase }}</a></li>
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action" (click)="editEmployee(record.employeeId)"><i
                                        class="fa fa-edit"></i> Modify</a></li>
                                        <li><a [routerLink]="['/'+AppFrontRoutes.EMPLOYEE_VIEW+'/'+record.employeeId]"
                                          class="blue_action"><i class="glyphicon glyphicon-eye-open"></i> {{lang.view}}</a>
                                      </li>

                                      <li><a (click)="resign(record.employeeId)"
                                        class="red_action"><i class="glyphicon glyphicon-remove"></i>RESIGN</a>
                                    </li>

                                    <!-- <li><a (click)="hired(record.employeeId)"
                                      class="green_action"><i class="glyphicon glyphicon-plus"></i> HIRED</a>
                                  </li> -->
                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                  <div role="tabpanel" class="tab-pane" id="resignTab">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">
                        
                        
                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport2" data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>
                        
                        
                          <a class="plus-import" data-toggle="modal" data-target="#datatableImport1" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>
                        
                        
                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="reassignedSearch"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                      

                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions2" class="table-striped table-sm row-border hover"
                        id="table1" *ngIf="records">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox" value=""><i></i>
                              </label>
                            </th>
                            <th>{{ lang.sno }}</th>
                            <th>{{ lang.name }}</th>
                            <th>{{ lang.surname }}</th>
                            <th>{{ lang.age }}</th>
                            <th>{{ lang.email }}</th>
                            <th>{{ lang.phone }}</th>
                            <th>{{ lang.task }}</th>
                            <th>{{ lang.qualifications }}</th>
                            <th>{{ lang.assumptionData }}</th>
                            <th style="display: none;">{{ lang.taxCode }}</th>
                            <th style="display: none;">{{ lang.dateofBirth }}</th>
                            <th style="display: none;">{{ lang.placeofBirth }}</th>
                            <th style="display: none;">{{ lang.address }}</th>
                            <th style="display: none;">{{ lang.titleofStudy }}</th>
                            <th style="display: none;">{{ lang.hourlyCost }}</th>
                            <!-- <th>{{ lang.status }}</th>  -->
                            <th>Actiosn</th>
                          </tr>
                        </thead>
                        <tbody dragula="records" [(dragulaModel)]="records">
                          <tr *ngFor="let record of resign_record let i = index" id="{{record.employeeId}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td><a
                                [routerLink]="['/'+AppFrontRoutes.EMPLOYEE_VIEW+'/'+record.employeeId]">{{record.employee_name}}</a>
                            </td>
                            <td>{{record.employee_surname}}</td>
                            <td>{{record.age}}</td>
                            <td>{{record.employee_email}}</td>
                            <td>{{record.employee_phone}}</td>
                            <td>{{record.employee_task}}</td>
                            <td>{{record.employee_qualification}}</td>
                            <td>{{record.employee_assumption_date}}</td>
                            <td style="display: none;">{{record.employee_tax_code}}</td>
                            <td style="display: none;">{{record.emp_dob}}</td>
                            <td style="display: none;">{{record.employee_placeOfbirth}}</td>
                            <td style="display: none;">{{record.employee_address}}</td>
                            <td style="display: none;">{{record.employee_timeOfstudy}}</td>
                            <td style="display: none;">{{record.employee_houly_cost}}</td>
                             <!-- <td>
                              <div [innerHTML]="record.status"></div>
                            </td> -->
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="blue_action" (click)="delete(record.employeeId)"><i
                                        class="fa fa-trash"></i> {{ lang.erase }}</a></li>
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action" (click)="editEmployee(record.employeeId)">
                                      <i class="fa fa-edit"></i> Modify</a></li>

                                        <li><a [routerLink]="['/'+AppFrontRoutes.EMPLOYEE_VIEW+'/'+record.employeeId]"
                                          class="blue_action"><i class="glyphicon glyphicon-eye-open"></i> {{lang.view}}</a>
                                      </li>

                                      <li><a (click)="hired(record.employeeId)"
                                        class="green_action"><i class="glyphicon glyphicon-plus"></i> HIRE</a>
                                    </li> 


                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                </div>

              </div>



              <div role="tabpanel" *ngSwitchCase="'calendar'">

                <div class="row p-10">

                  <div class="col-sm-9">
                  </div>

                  <div class="col-sm-3">
                    <div class="social-icons">
                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>
                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>
                    </div>
                  </div>

                </div>

                <app-servicing-calendar></app-servicing-calendar>
              </div>



            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ lang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableImport1" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left">IMPORT DATA</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a [routerLink]="">Click here</a> to download to csv format file
              </font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">Save</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableImport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left">IMPORT DATA</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" class="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a [routerLink]="">Click here</a> to download to csv format file
              </font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick2()">Save</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">SELECT COLUMNS</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i>Select All</label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active columns</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>

